module.exports = __webpack_public_path__ + "img/me_us_logo@3x.6e16292b.png";